"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserLocations {
}
exports.UserLocations = UserLocations;
//# sourceMappingURL=UserLocations.js.map